import { useState, useEffect } from "react";

function Modal({ showModal, todos, onClose, onConfirmToggle, onConfirmDelete, onConfirmClear, onConfirmEdit }) {
  const [editText, setEditText] = useState("");
  const [editDeadline, setEditDeadline] = useState("");

  const isString = typeof showModal === "string";
  const isEdit = !!showModal && !isString && showModal.type === "edit";

  useEffect(() => {
    if (isEdit && showModal) {
      setEditText(showModal.text || "");
      setEditDeadline(showModal.deadline || "");
    }
  }, [isEdit, showModal]);

  const getMessage = () => {
    if (isString) return showModal;

    if (showModal.type === "done") {
      const todo = todos.find((t) => t.id === showModal.id);
      const isDone = todo?.done;
      return isDone
        ? "Kembalikan tugas ini ke belum selesai?"
        : "Tandai tugas ini selesai?";
    }

    if (showModal.type === "delete") return "Yakin hapus tugas ini?";
    if (showModal.type === "clear") return "Hapus semua tugas?";
    return "";
  };

  const handleConfirm = () => {
    if (isString) return onClose();

    if (isEdit) {
      onConfirmEdit({
        id: showModal.id,
        text: editText,
        deadline: editDeadline,
      });
      return;
    }

    if (showModal.type === "done") onConfirmToggle(showModal.id);
    else if (showModal.type === "delete") onConfirmDelete(showModal.id);
    else onConfirmClear();
  };

  if (!showModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box" role="dialog" aria-modal="true">
        {isEdit ? (
          <>
            <h2 style={{ marginTop: 0, marginBottom: 16 }}>Edit tugas</h2>
            <div className="form-group" style={{ marginBottom: 12 }}>
              <label htmlFor="edit-task">Tugas</label>
              <input
                id="edit-task"
                type="text"
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
              />
            </div>
            <div className="form-group" style={{ marginBottom: 20 }}>
              <label htmlFor="edit-deadline">Deadline</label>
              <input
                id="edit-deadline"
                type="date"
                value={editDeadline}
                onChange={(e) => setEditDeadline(e.target.value)}
              />
            </div>
          </>
        ) : (
          <p>{getMessage()}</p>
        )}
        <div className="modal-actions">
          <button type="button" onClick={handleConfirm} className="primary-btn">
            {isString ? "OK" : "Ya"}
          </button>
          <button type="button" onClick={onClose} className="secondary-btn">
            Batal
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
